import { Component, Input } from '@angular/core';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';

@Component({
  template: `
    <fl-bit class="Header">
      <fl-heading
        [size]="HeadingSize.XSMALL"
        [headingType]="HeadingType.H4"
      >
        {{ title }}
      </fl-heading>
    </fl-bit>
    <fl-bit class="MainBody">
      {{ warning }}
    </fl-bit>
    <div class="ActionContainer">
      <fl-button class="ActionButton"
        [color]="ButtonColor.SECONDARY"
        (click)="modalRef.close(true)"
      >
        {{ confirm }}
      </fl-button>
      <fl-button class="ActionButton"
        [color]="ButtonColor.DEFAULT"
        (click)="modalRef.close(false)"
      >
        {{ cancel }}
      </fl-button>
    </div>
  `,
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  ButtonColor = ButtonColor;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;

  @Input() cancel = 'Cancel';
  @Input() confirm = 'Confirm';
  @Input() title: string;
  @Input() warning: string;

  modalRef: ModalRef<ConfirmModalComponent>;

  constructor(modalRef: ModalRef<ConfirmModalComponent>) {
    this.modalRef = modalRef;
  }
}
